import React from 'react'
// libs
import styled from 'styled-components'
import { useRouter } from 'hooks/useRouter'
import { useDispatch } from 'react-redux'
import { useMutation } from '@apollo/client/react'
// hooks
import { useShowModal } from 'hooks'
// components
import { IconButton } from 'components/UI'
// constants
import { Modals } from 'constants/modals'
// store
import { deleteRiskTemplate } from 'store/reducers/riskTemplates'
// graphql
import { RISK_TEMPLATE_DELETE_MUTATION } from 'graphql/risk/mutations'
// icons
import DeleteIconOrigin from '@mui/icons-material/Delete'
// themes
import colors from 'themes/colors'
// utils
import { size } from 'polished'
import { handleError } from 'utils/errors/handlers'

const DeleteIcon = styled(DeleteIconOrigin)`
  && {
    ${size('24px')};
    fill: ${colors.white};
  }
`

interface Props {
  templateId: string
}

const DeleteRiskTemplateButton: React.FC<Props> = ({ templateId }) => {
  const router = useRouter()
  const dispatch = useDispatch()

  const [riskTemplateDeleteMutation] = useMutation(RISK_TEMPLATE_DELETE_MUTATION)

  const { showModal } = useShowModal({ modalType: Modals.CONFIRM_DELETE_RISK_TEMPLATE_MODAL })

  const handleCLick = () => {
    showModal({
      width: 'sm',
      handleConfirm: async () => {
        try {
          await riskTemplateDeleteMutation({
            variables: {
              id: templateId
            }
          })

          dispatch(deleteRiskTemplate(templateId))

          await router.push('/forms')
        } catch (e) {
          handleError(e, 'DeleteRiskTemplateButton.riskTemplateDeleteMutation')
        }
      }
    })
  }

  return (
    <IconButton onClick={handleCLick} description='Delete Template'>
      <DeleteIcon color='inherit' />
    </IconButton>
  )
}

export default DeleteRiskTemplateButton
